#import "@/apollo/fragments/Annotation.gql"

mutation UpdateQAAnnotationOnComputedDeliverable(
    $annotationId: ID!
    $description: String!
    $timeline: Float!
    $xpos: Int!
    $ypos: Int!
    $mentions: [String]
) {
    updateQAAnnotationOnComputedDeliverable(
        annotationId: $annotationId
        description: $description
        timeline: $timeline
        xpos: $xpos
        ypos: $ypos
        mentions: $mentions
    ) {
        ...Annotation
    }
}
